import { styled } from '@linaria/react';

import {
  InfoAside,
  WarningAside,
  SuccessAside,
} from '@/components/Aside';
import { Popover as TooltipPopover } from '@/components/Tooltip';

const InlineCode = styled.code`
  /* <code> is used inside <pre> by CodeSnippet, and we do *not* want to style that case. So we'll exclude it here */
  :not(pre) & {
    position: relative;
    display: inline;
    font-family: var(--font-family-mono);
    font-size: 0.9375em;
    font-style: normal;
    letter-spacing: -0.5px;
    padding: 2px 6px;
    margin: 1px -1px;
    background: var(--color-code-bg);
    border-radius: 3px;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;

    html[data-color-mode='light'] & {
      mix-blend-mode: darken;
    }

    html[data-color-mode='dark'] & {
      mix-blend-mode: lighten;
    }

    ${InfoAside} & {
      background: var(--color-info-200);
    }
    ${SuccessAside} & {
      background: var(--color-success-200);
    }
    ${WarningAside} & {
      background: var(--color-warning-200);
    }

    /*
      There's a bit of an optical illusion happening; in Light Mode, some of the background colors *look* lighter than the backgrounds of <CodeSnippet>s, even though they're the exact same color.
      For folks on modern browsers, we'll tint it for them via relative color syntax.
    */
    html[data-color-mode='light'] ${InfoAside} & {
      background: hsl(from var(--color-info-200) h s calc(l * 0.98));
    }
    html[data-color-mode='light'] ${SuccessAside} & {
      background: hsl(
        from var(--color-success-200) h s calc(l * 0.94)
      );
    }
    html[data-color-mode='light'] ${WarningAside} & {
      background: hsl(
        from var(--color-warning-200) h s calc(l * 0.94)
      );
    }

    /*
      When <code> is inside a tooltip, we need to tweak its colors.
    */
    ${TooltipPopover} & {
      html[data-color-mode='light'] & {
        background: hsl(0deg 0% 0% / 0.2);
      }

      html[data-color-mode='dark'] & {
        background: hsl(210deg 23% 82%);
      }
    }
  }

  a & {
    border-bottom: 2px solid var(--color-primary);
    padding-bottom: 0px;
    border-radius: 3px 3px 1px 1px;
  }
`;

export default InlineCode;
